import { Button, DialogContent, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { Link } from "react-router";

import { ROUTES } from "~/constants/routing";
import { FeatureKey } from "~/types/subscription";

interface IUserLimitDialogContentProps {
  onClose: () => void;
}

export const UserLimitDialogContent: FC<IUserLimitDialogContentProps> = ({
  onClose,
}) => {
  return (
    <DialogContent>
      <Stack
        sx={{
          alignItems: "center",
          gap: 2
        }}>
        <Typography variant="caption">
          Upgrade your plan to track unlimited events and unlock alerts.
        </Typography>
        <Button
          component={Link}
          to={ROUTES.pricing.createURL(FeatureKey.WATCHLIST_NO_LIMITS)}
          onClick={onClose}
          variant="contained"
          size="small"
          color="primary"
        >
          Upgrade Plan
        </Button>
      </Stack>
    </DialogContent>
  );
};
